import React from "react";
import { DownloadIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import { getFormatDate } from "~/libs/getFormatDate";

import { DataRow, DataRows } from "../components/DataRows";
import { formatDisplayValue } from "../model/display";
import { TEmployeeView } from "../model/types";

import s from "../EmployeeProfileView.less";

interface IPersonalDataViewSectionProps {
  employee: TEmployeeView;
}

const PersonalDataViewSection = ({ employee }: IPersonalDataViewSectionProps) => {
  const { t } = useTranslation();
  const consents = employee.Consents || [];

  return (
    <section className={s.section}>
      <h2 className={s.sectionTitle}>{t("employee.listTitleData")}</h2>
      <div className={s.personalLayout}>
        <div className={s.photo}>
          {employee.Photo?.link ? (
            <img src={employee.Photo.link} alt={t("employee.photoID")} />
          ) : (
            <span className={s.photoPlaceholder}>{formatDisplayValue(null)}</span>
          )}
        </div>

        <DataRows personal>
          <DataRow label={`${t("employee.id")}:`}>
            {formatDisplayValue(employee.id)}
          </DataRow>
          <DataRow label={`${t("employee.surname")}:`}>
            {formatDisplayValue(employee.surname)}
          </DataRow>
          <DataRow label={`${t("employee.name")}:`}>
            {formatDisplayValue(employee.name)}
          </DataRow>
          <DataRow label={`${t("employee.middleName")}:`}>
            {formatDisplayValue(employee.middleName)}
          </DataRow>
          <DataRow label={`${t("employee.gender")}:`}>
            {employee.gender ? t(`employee.${employee.gender}`) : formatDisplayValue(null)}
          </DataRow>
          <DataRow label={`${t("employee.birthDay")}:`}>
            {employee.birthDay
              ? getFormatDate(String(employee.birthDay), true)
              : formatDisplayValue(null)}
          </DataRow>
          <DataRow label={`${t("employee.workPhone")}:`}>
            {formatDisplayValue(employee.workPhone)}
          </DataRow>
        </DataRows>
      </div>

      {consents.length > 0 && (
        <DataRows>
          {consents.map((consent, index) => {
            const link = consent?.File?.link;
            const linkName = consent?.File?.name;
            const label = `${t("employee.agree_with_consents_without_system")} ${consent?.PersonalInfo?.name ?? ""} ${t("employee.for")} ${consent?.PersonalInfo?.InformationSystem?.name ?? ""}`;

            return (
              <DataRow key={`${link}-${index}`} label={label.trim()} alignTop>
                {link ? (
                  <a className={s.linkFile} href={link} target="_blank" rel="noreferrer">
                    {linkName}
                    <DownloadIcon size={12} fill="#495a64" />
                  </a>
                ) : (
                  formatDisplayValue(null)
                )}
              </DataRow>
            );
          })}
        </DataRows>
      )}
    </section>
  );
};

export default PersonalDataViewSection;
